import { scan } from 'react-scan'; // import this BEFORE react
import '@fontsource-variable/montserrat';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import { AllAccessRoles } from './constants/applicationRoles.ts';
import { getAxios } from './lib/axios';

if (typeof window !== 'undefined' && window.location.hostname.includes('localhost')) {
  scan({
    enabled: true
  });
}

(window as any).getAxios = getAxios;
(window as any).superAdminRoles = AllAccessRoles;

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(
  <Sentry.ErrorBoundary>
    <App />
  </Sentry.ErrorBoundary>
);
